import { createContext } from "react";
import { ProjectsManager } from "../states/ProjectsManager";

export const ProjectsManagerContext = createContext<
  ProjectsManager | undefined
>(undefined);
export const ProjectsManagerContextProvider = ProjectsManagerContext.Provider;
